import functions from './functions';

$(() => {

    $('form.form-inquiry-tour').on('submit', e => {
        e.preventDefault();

        const $form = $(e.currentTarget);

        let params = {};
        $.each($(e.currentTarget).serializeArray(), function (i, field) {
            params[field.name] = field.value;
        });

        const $dates = $form.find('[name="dates"]');
        const $guests = $form.find('[name="guests"]');
        $dates.parents('.datepicker-range').toggleClass('focus', ! params['dates'] && ! $dates.val());
        $guests.parents('.guests').toggleClass('focus', ! params['guests'] && ! $guests.val());

        $dates.on('change', e => {
            $(e.currentTarget).parents('.datepicker-range').removeClass('focus');
        });
        $guests.on('change', e => {
            $(e.currentTarget).parents('.guests').removeClass('focus');
        });

        if(params['dates'] && params['guests']) {
            $('.contact-btn').addClass('d-none');
            $('.contact-spinner').removeClass('d-none');
            $('.contact-spinner').addClass('d-flex');

            let dates = params['dates'].split(' - ');
            params['dateFrom'] = dates[0];
            params['dateTo'] = dates[1] ? dates[1] : params['dateFrom'];

            params['note'] = params['budget'] ? ('Budžet: ' + params['budget'] + '; ') : '';
            params['note'] += params['placeFrom'] ? ('Mjesto polaska: ' + params['placeFrom'] + '; ') : '';
            params['note'] += params['placeTo'] ? ('Mjesto povratka: ' + params['placeTo'] + '; ') : '';
            params['note'] += params['message'] ? ('Poruka: ' + params['message'] + '; ') : '';
    
            params['language'] = functions.getLang();
    
            params['requestId'] = Math.floor(Math.random() * ((9999999 - 1000000) + 1) + 1000000);

            //console.log(params);
    
            grecaptcha.ready(function () {
                grecaptcha.execute('6LeU1cUeAAAAAIFFN2oVRqyNc5O2MPeE4Del3Ofa', { action: 'contact' }).then(function (token) {
                    params['gRecaptchaToken'] = token;
                    params = functions.getDataForUrl(params);
                    $.post('/services/inquiry/', params).then(response => {
    
                        response = JSON.parse(response);
                        //console.log(response);
                        
                        $('[id^=tourModal]').modal('hide');
                        $('#contact-modal').modal('show');
                        $(".response-output").html(response.data);
    
                        $('.contact-btn').removeClass('d-none');
                        $('.contact-spinner').removeClass('d-flex');
                        $('.contact-spinner').addClass('d-none');
    
                        setTimeout(() => { 
                            $('#contact-modal').modal('hide');
                        }, 4000);
    
                        if (response.status == true) {
                            e.currentTarget.reset();
                        }
                    });
                });
            });
        }

    });

});

